var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 3.125V10.0547L18.7461 12.6719L12.8891 3.125Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 3.125L7.03125 12.6719L12.8891 10.0547V3.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 17.1625V21.871L18.75 13.7625L12.8891 17.1625Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 21.871V17.1617L7.03125 13.7625L12.8891 21.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 16.0727L18.7461 12.6719L12.8891 10.0563V16.0727Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 12.6719L12.8891 16.0727V10.0563L7.03125 12.6719Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthPurple);
export default __webpack_public_path__ + "static/media/eth-purple.0e90bace28275083cdf8da8248c0cd10.svg";
export { ForwardRef as ReactComponent };